import { PIMSCopy } from "./types"

import RhapsodyLogo from "~images/pages/pims/logos/rhapsody.png"
import RhapsodyGraphic from "~images/pages/pims/graphics/rhapsody.png"
import Messaging from "~images/pages/features/messaging/messaging-landing.png"
import Analytics from "~images/pages/features/enterprise/enterprise-landing.png"
import OnlineBooking from "~images/pages/features/online-scheduling/online-scheduling.png"
import ClientPortal from "~images/pages/features/portal/portal-landing.png"

export const RHAPSODY_COPY: PIMSCopy = {
    pims: "Rhapsody",
    logo: RhapsodyLogo,
    image: RhapsodyGraphic,
    benefits: [
        {
            twoWordTitle: "SMS Power",
            heading: "Skyrocket Compliance with Texting",
            paragraph: [
                "Forget email's measly 21% open rate. Our text reminders boast a jaw-dropping 98% open rate, slashing no-shows and boosting compliance through the roof.",
                "Plus, clients can text you back, streamlining communication and freeing up your phone lines. Watch client satisfaction soar as you effortlessly stay connected.",
            ],
            image: Messaging,
        },
        {
            twoWordTitle: "Data Mastery",
            heading: "Unlock Practice Insights Instantly",
            paragraph: [
                "Our lightning-fast system generates crucial insights in seconds, letting you dive deep into your practice's performance at a moment's notice.",
                "With industry-leading analytics, we transform your complex data into crystal-clear actionable insights. No more Excel headaches - just powerful, practice-changing information at your fingertips.",
            ],
            image: Analytics,
        },
        {
            twoWordTitle: "24/7 Bookings",
            heading: "Best-in-Class Appointment System",
            paragraph: [
                "Transform your practice with round-the-clock online booking. Our intelligent scheduling system puts you in full control, allowing clients to book appointments that fit your precise availability.",
                "Kiss double-bookings goodbye! Our foolproof system ensures your schedule stays optimized, maximizing your time and keeping your practice running like a well-oiled machine.",
            ],
            image: OnlineBooking,
        },
        {
            twoWordTitle: "Client Magnet",
            heading: "Cultivate Unshakeable Client Loyalty",
            paragraph: [
                "Elevate your practice with a game-changing loyalty program, automated review requests, and a state-of-the-art pet health portal. Watch client engagement skyrocket!",
                "Delight your clients with unparalleled convenience while you enjoy the perks: increased revenue, rock-solid client retention, and a reputation that attracts pet owners like never before.",
            ],
            image: ClientPortal,
        },
    ],
}
